export default __webpack_public_path__ + "files/sampling-gltg-4e4a1d6487316cab923f67f66abe0609.jpg";